import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { DeckglMapboxComponent } from './deckgl-mapbox/deckgl-mapbox.component';
import { Mobile2cadComponent } from './mobile2cad/mobile2cad.component';
import { DotappComponent } from './dotapp/dotapp.component';
import { DottestComponent } from './dottest/dottest.component';
import { Npr3ddemoComponent } from './npr3ddemo/npr3ddemo.component';

@NgModule({
    declarations: [
        AppComponent,
        DeckglMapboxComponent, Mobile2cadComponent, DotappComponent, DottestComponent, Npr3ddemoComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule, FormsModule,
        AppRoutingModule], providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())]
})
export class AppModule { }
